import { createFeatureSelector, createSelector } from '@ngrx/store';

import { orderHistorySkuInformationAdapter, proposalDeliveryMomentsAdapter, silosAdapter, silosWithProductListAdapter, variantsAdapter } from './reducer';
import { GetMultipleProductDeliveryDatesWith0FlexibilityResponse } from '../models/product-delivery-moment.models';
import { ExpandedSilosState, ProductState } from '../models/product.models';

const siloSelectors = silosAdapter.getSelectors();
const silosWithProductListSelectors = silosWithProductListAdapter.getSelectors();
const variantsSelectors = variantsAdapter.getSelectors();
const proposalDeliveryMomentsSelectors = proposalDeliveryMomentsAdapter.getSelectors();
const orderHistorySkuInformationSelectors = orderHistorySkuInformationAdapter.getSelectors();

export const selectProductState = createFeatureSelector<ProductState>('product');

export const selectExpandedSilosState = createFeatureSelector<ExpandedSilosState>('expandedSilos');

export const selectFavoritesLoading = createSelector(selectProductState, (store) => store.favoritesLoading);

export const selectSkuCatalogItems = createSelector(selectProductState, (store) => store?.skuCatalogItems);

export const selectFavorites = createSelector(selectProductState, (store) => store?.favoriteSkus);

export const selectSkuCatalogItemsNotAvailable = createSelector(selectProductState, (state) => state?.skuCatalogItemsNotAvailable);

export const selectSkuCatalogItemsLoaded = createSelector(selectProductState, (state) => state?.skuCatalogItemsLoaded);

export const selectSilosWithProductListState = createSelector(selectProductState, (state) => state?.silosWithProductList);

export const selectSilosWithProductLists = createSelector(selectSilosWithProductListState, silosWithProductListSelectors.selectAll);

export const selectSiloWithProductListById = (siloId: number) =>
  createSelector(selectSilosWithProductListState, silosWithProductListSelectors.selectEntities, (entities) => {
    const silo = entities.entities[siloId];
    return silo;
  });
export const selectSilosWithProductListsLoaded = createSelector(selectProductState, (state) => state?.silosWithProductListLoaded);

export const selectExpandedSiloIds = createSelector(selectExpandedSilosState, (state) => state?.expandedSiloIds);

export const selectSilosState = createSelector(selectProductState, (state) => state?.silos);

export const selectSilos = createSelector(selectSilosState, siloSelectors.selectAll);

export const selectSilosNotAvailable = createSelector(selectProductState, (state) => state?.silosNotAvailable);

export const selectSilosLoaded = createSelector(selectProductState, (state) => state?.silosLoaded);

export const selectSilosInUseOnDates = createSelector(selectProductState, (state) => state?.silosInUseOnDates);

export const selectDeliveryMoments = createSelector(selectProductState, (state) => state?.deliveryMoments);

export const selectDeliveryMomentsNotAvailable = createSelector(selectProductState, (state) => state?.deliveryMomentsNotAvailable);

const selectVariantsState = createSelector(selectProductState, (state) => state?.variants);
export const selectVariants = createSelector(selectVariantsState, variantsSelectors.selectAll);

export const selectVariantsNotAvailable = createSelector(selectProductState, (state) => state?.variantsNotAvailable);

export const selectVariantsLoaded = createSelector(selectProductState, (state) => state?.variantsLoaded);

export const selectSelectedCartLine = createSelector(selectProductState, (state) => state?.selectedCartLine);

export const selectSelectedProductSiloLine = createSelector(selectProductState, (state) => state?.selectedProductSiloLine);

const selectProposalDeliveryMomentsState = createSelector(selectProductState, (state) => state?.proposalDeliveryMoments);

const selectProposalDeliveryMoments = createSelector(selectProposalDeliveryMomentsState, proposalDeliveryMomentsSelectors.selectAll);

const selectProposalZeroFlexibilityDeliveryMomentsState = createSelector(selectProductState, (state) => state?.proposalZeroFlexibilityDeliveryMoments);

export const selectProposalZeroFlexibilityDeliveryMoments = createSelector(
  selectProposalZeroFlexibilityDeliveryMomentsState,
  proposalDeliveryMomentsSelectors.selectAll,
);

export const selectProposalDeliveryMomentsAndZeroFlex = createSelector(
  selectProposalDeliveryMoments,
  selectProposalZeroFlexibilityDeliveryMoments,
  (proposalDeliveryMoments, proposalZeroFlexibilityDeliveryMoments) =>
    ({
      deliveryDates: proposalDeliveryMoments,
      zeroFlexibilityDeliveryDates: proposalZeroFlexibilityDeliveryMoments,
    }) as GetMultipleProductDeliveryDatesWith0FlexibilityResponse,
);

const selectOrderHistorySkuInformationState = createSelector(selectProductState, (state) => state?.orderHistorySkuInformation);
export const selectOrderHistorySkuInformation = createSelector(selectOrderHistorySkuInformationState, orderHistorySkuInformationSelectors.selectAll);
